module.exports = __webpack_public_path__ + "img/image 2430.71e4ec69.png";